import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { ImportsCardsPanel } from './ImportsCardsPanel'
import { HOME_ROUTES } from '@/modules/home/routes-typed'
import { RouteComponentProps } from '@/app/navigation/withRouter'
import { ScannedChartsSection } from './components/ScannedChartsSection'

export const ImportsHomeCards = ({
  match,
}: RouteComponentProps<{ companyId: string }>) => {
  const { companyId } = match.params
  const navigate = useNavigate()
  const [chartListVersion, setChartListVersion] = React.useState(0)

  const handleSuccess = () => {
    navigate(HOME_ROUTES.dashboard.buildPath({ companyId: companyId }))
  }

  return (
    <div className="tw-flex tw-flex-col tw-gap-6">
      <ImportsCardsPanel
        companyId={companyId}
        onSuccess={handleSuccess}
        onChartSuccess={() => setChartListVersion((version) => version + 1)}
      />
      <ScannedChartsSection key={`${companyId}-${chartListVersion}`} companyId={companyId} />
    </div>
  )
}
